import { render } from "./event_highlight_promote.vue?vue&type=template&id=30211242&scoped=true"
import script from "./event_highlight_promote.vue?vue&type=script&lang=js"
export * from "./event_highlight_promote.vue?vue&type=script&lang=js"

import "./event_highlight_promote.vue?vue&type=style&index=0&id=30211242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30211242"]])

export default __exports__